export const bearer = (token?: string | null): Headers => {
	if (token) {
		const headers = {
			Authorization: `Bearer ${token}`
		}
		return new Headers(headers)
	} 
	return new Headers({})
}
